/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { openPositionConvertAdjustmentSchema } from './openPositionConvertAdjustmentSchema';

export const openPositionConvertPreviewResponseSchema = z.object({
  get adjustments() {
    return z.array(openPositionConvertAdjustmentSchema);
  },
  bindingSegment: z.string().nullish(),
  outcome: z.enum(['WITHIN_CAP', 'AUTO_SPLIT', 'INCOMING_EXCEEDS_CAP']),
});
